import React, { useState, useRef } from 'react';

// SVG Icons
export const CloseIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
  </svg>
);

export const ExpandIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
  </svg>
);

export const CopyIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
  </svg>
);

export const ChipIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    {/* Outer connections */}
    <rect x="1" y="8" width="2" height="2" />
    <rect x="1" y="14" width="2" height="2" />
    <rect x="21" y="8" width="2" height="2" />
    <rect x="21" y="14" width="2" height="2" />
    <rect x="8" y="1" width="2" height="2" />
    <rect x="14" y="1" width="2" height="2" />
    <rect x="8" y="21" width="2" height="2" />
    <rect x="14" y="21" width="2" height="2" />

    {/* Connection lines */}
    <rect x="3" y="8.5" width="2" height="1" />
    <rect x="3" y="14.5" width="2" height="1" />
    <rect x="19" y="8.5" width="2" height="1" />
    <rect x="19" y="14.5" width="2" height="1" />
    <rect x="8.5" y="3" width="1" height="2" />
    <rect x="14.5" y="3" width="1" height="2" />
    <rect x="8.5" y="19" width="1" height="2" />
    <rect x="14.5" y="19" width="1" height="2" />

    {/* Main chip body */}
    <rect x="5" y="5" width="14" height="14" rx="2" stroke="currentColor" strokeWidth="1" fill="none" />

    {/* AI text */}
    <text x="12" y="14" fontFamily="Arial, sans-serif" fontSize="6" fontWeight="bold" textAnchor="middle" fill="currentColor">AI</text>
  </svg>
);

// InfoIcon Component
export const InfoIcon = ({ tooltip, theme = 'blue' }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const iconRef = useRef(null);

  const getColors = () => {
    switch (theme) {
      case 'blue':
        return {
          text: 'text-blue-700',
          border: 'border-blue-700'
        };
      case 'green':
        return {
          text: 'text-green-700',
          border: 'border-green-700'
        };
      case 'gray':
        return {
          text: 'text-gray-200',
          border: 'border-gray-200'
        };
      default:
        return {
          text: 'text-blue-700',
          border: 'border-blue-700'
        };
    }
  };

  const colors = getColors();

  const handleMouseEnter = () => {
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setTooltipPosition({
        x: rect.left + rect.width / 2,
        y: rect.top - 8
      });
    }
    setShowTooltip(true);
  };

  return (
    <div className="relative inline-block">
      <span
        ref={iconRef}
        className={`inline-flex items-center justify-center w-5 h-5 text-sm ${colors.text} border ${colors.border} rounded-full`}
        style={{fontFamily: 'Times, serif'}}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => setShowTooltip(false)}
      >
        i
      </span>

      {showTooltip && (
        <div
          className="fixed px-3 py-2 text-sm text-white bg-gray-800 rounded-lg shadow-lg whitespace-normal max-w-xs pointer-events-none text-center"
          style={{
            zIndex: 9999,
            left: tooltipPosition.x,
            top: tooltipPosition.y,
            transform: 'translate(-50%, -100%)'
          }}
        >
          {tooltip}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
        </div>
      )}
    </div>
  );
};
